export const personalTableViewTranslations = {
  fr: {
    'Apply saved view': 'Appliquer la vue enregistrée',
    'Personal table views': 'Vues personnelles du tableau',
    'Personal view': 'Vue personnelle',
    'Default view': 'Vue par défaut',
    'Save current view': 'Enregistrer la vue actuelle',
    'Rename view': 'Renommer la vue',
    'Delete view': 'Supprimer la vue',
    'Restore default view': 'Rétablir la vue par défaut',
    'Current settings differ from the saved view.': 'Les réglages actuels diffèrent de la vue enregistrée.',
    'Saved view active.': 'Vue enregistrée active.',
    'Default view or custom settings.': 'Vue par défaut ou réglages personnalisés.',
    'Private to this user, tenant, organization and browser. Views do not sync across devices.': 'Privé pour cet utilisateur, locataire, organisation et navigateur. Les vues ne sont pas synchronisées entre appareils.',
    'Search and organization or skill filters are not saved. Use a non-sensitive view name.': 'La recherche et les filtres d’organisation ou de compétence ne sont pas enregistrés. Utilisez un nom sans données sensibles.',
    'Rename personal view': 'Renommer la vue personnelle',
    'Save personal view': 'Enregistrer une vue personnelle',
    'View name': 'Nom de la vue',
    'Rename': 'Renommer',
    'Save': 'Enregistrer',
    'Cancel': 'Annuler',
    'Views cannot be saved in this browser. Changes remain available while this table is open.': 'Les vues ne peuvent pas être enregistrées dans ce navigateur. Les changements restent disponibles tant que le tableau est ouvert.',
    'Delete personal view?': 'Supprimer la vue personnelle ?',
    'Only this saved configuration will be deleted. Records are unchanged.': 'Seule cette configuration sera supprimée. Les enregistrements restent inchangés.',
    'Select eligible records on this page': 'Sélectionner les enregistrements admissibles de cette page',
    'Select {name}': 'Sélectionner {name}',
    '{count} selected on this page': '{count} sélectionnés sur cette page',
    'Selection applies only to eligible records on the current page.': 'La sélection concerne seulement les enregistrements admissibles de la page actuelle.',
    'Select current page': 'Sélectionner la page actuelle',
    'Clear selection': 'Effacer la sélection',
    'Open column settings': 'Ouvrir les paramètres des colonnes',
    'Open personal view selector': 'Ouvrir le sélecteur de vue personnelle',
    'Clear table filters': 'Effacer les filtres du tableau',
    'Clear current-page selection': 'Effacer la sélection de la page actuelle',
    'Enter a view name of 1 to 60 characters.': 'Saisissez un nom de vue de 1 à 60 caractères.',
    'A personal view already has this name.': 'Une vue personnelle porte déjà ce nom.',
    'You can save up to 12 personal views.': 'Vous pouvez enregistrer jusqu’à 12 vues personnelles.',
    'This personal view is no longer available.': 'Cette vue personnelle n’est plus disponible.',
    'Personal view saved.': 'Vue personnelle enregistrée.',
    'Personal view applied. Unsupported settings are omitted.': 'Vue personnelle appliquée. Les réglages non pris en charge sont omis.',
    'Personal view renamed.': 'Vue personnelle renommée.',
    'Personal view deleted.': 'Vue personnelle supprimée.',
    'Default view restored.': 'Vue par défaut rétablie.',
  },
  ar: {
    'Apply saved view': 'تطبيق العرض المحفوظ',
    'Personal table views': 'طرق عرض الجدول الشخصية',
    'Personal view': 'طريقة عرض شخصية',
    'Default view': 'العرض الافتراضي',
    'Save current view': 'حفظ العرض الحالي',
    'Rename view': 'إعادة تسمية العرض',
    'Delete view': 'حذف العرض',
    'Restore default view': 'استعادة العرض الافتراضي',
    'Current settings differ from the saved view.': 'تختلف الإعدادات الحالية عن العرض المحفوظ.',
    'Saved view active.': 'العرض المحفوظ نشط.',
    'Default view or custom settings.': 'عرض افتراضي أو إعدادات مخصصة.',
    'Private to this user, tenant, organization and browser. Views do not sync across devices.': 'خاص بهذا المستخدم والمستأجر والمؤسسة والمتصفح. لا تتزامن العروض بين الأجهزة.',
    'Search and organization or skill filters are not saved. Use a non-sensitive view name.': 'لا يتم حفظ البحث أو مرشحات المؤسسة أو المهارة. استخدم اسماً لا يتضمن معلومات حساسة.',
    'Rename personal view': 'إعادة تسمية العرض الشخصي',
    'Save personal view': 'حفظ عرض شخصي',
    'View name': 'اسم العرض',
    'Rename': 'إعادة التسمية',
    'Save': 'حفظ',
    'Cancel': 'إلغاء',
    'Views cannot be saved in this browser. Changes remain available while this table is open.': 'لا يمكن حفظ العروض في هذا المتصفح. تظل التغييرات متاحة أثناء فتح الجدول.',
    'Delete personal view?': 'حذف العرض الشخصي؟',
    'Only this saved configuration will be deleted. Records are unchanged.': 'سيتم حذف هذا التكوين المحفوظ فقط. لا تتغير السجلات.',
    'Select eligible records on this page': 'تحديد السجلات المؤهلة في هذه الصفحة',
    'Select {name}': 'تحديد {name}',
    '{count} selected on this page': 'تم تحديد {count} في هذه الصفحة',
    'Selection applies only to eligible records on the current page.': 'يقتصر التحديد على السجلات المؤهلة في الصفحة الحالية.',
    'Select current page': 'تحديد الصفحة الحالية',
    'Clear selection': 'مسح التحديد',
    'Open column settings': 'فتح إعدادات الأعمدة',
    'Open personal view selector': 'فتح محدد العرض الشخصي',
    'Clear table filters': 'مسح مرشحات الجدول',
    'Clear current-page selection': 'مسح تحديد الصفحة الحالية',
    'Enter a view name of 1 to 60 characters.': 'أدخل اسم عرض من حرف إلى 60 حرفاً.',
    'A personal view already has this name.': 'يوجد عرض شخصي بهذا الاسم بالفعل.',
    'You can save up to 12 personal views.': 'يمكنك حفظ ما يصل إلى 12 عرضاً شخصياً.',
    'This personal view is no longer available.': 'لم يعد هذا العرض الشخصي متاحاً.',
    'Personal view saved.': 'تم حفظ العرض الشخصي.',
    'Personal view applied. Unsupported settings are omitted.': 'تم تطبيق العرض الشخصي. تم حذف الإعدادات غير المدعومة.',
    'Personal view renamed.': 'تمت إعادة تسمية العرض الشخصي.',
    'Personal view deleted.': 'تم حذف العرض الشخصي.',
    'Default view restored.': 'تمت استعادة العرض الافتراضي.',
  },
  tr: {
    'Apply saved view': 'Kayıtlı görünümü uygula',
    'Personal table views': 'Kişisel tablo görünümleri',
    'Personal view': 'Kişisel görünüm',
    'Default view': 'Varsayılan görünüm',
    'Save current view': 'Geçerli görünümü kaydet',
    'Rename view': 'Görünümü yeniden adlandır',
    'Delete view': 'Görünümü sil',
    'Restore default view': 'Varsayılan görünümü geri yükle',
    'Current settings differ from the saved view.': 'Geçerli ayarlar kayıtlı görünümden farklı.',
    'Saved view active.': 'Kayıtlı görünüm etkin.',
    'Default view or custom settings.': 'Varsayılan görünüm veya özel ayarlar.',
    'Private to this user, tenant, organization and browser. Views do not sync across devices.': 'Bu kullanıcıya, kiracıya, kuruluşa ve tarayıcıya özeldir. Görünümler cihazlar arasında eşitlenmez.',
    'Search and organization or skill filters are not saved. Use a non-sensitive view name.': 'Arama, kuruluş veya beceri filtreleri kaydedilmez. Hassas bilgi içermeyen bir ad kullanın.',
    'Rename personal view': 'Kişisel görünümü yeniden adlandır',
    'Save personal view': 'Kişisel görünümü kaydet',
    'View name': 'Görünüm adı',
    'Rename': 'Yeniden adlandır',
    'Save': 'Kaydet',
    'Cancel': 'İptal',
    'Views cannot be saved in this browser. Changes remain available while this table is open.': 'Görünümler bu tarayıcıda kaydedilemiyor. Değişiklikler tablo açıkken kullanılabilir.',
    'Delete personal view?': 'Kişisel görünüm silinsin mi?',
    'Only this saved configuration will be deleted. Records are unchanged.': 'Yalnızca bu kayıtlı yapılandırma silinecek. Kayıtlar değişmez.',
    'Select eligible records on this page': 'Bu sayfadaki uygun kayıtları seç',
    'Select {name}': '{name} seç',
    '{count} selected on this page': 'Bu sayfada {count} kayıt seçildi',
    'Selection applies only to eligible records on the current page.': 'Seçim yalnızca geçerli sayfadaki uygun kayıtlar için geçerlidir.',
    'Select current page': 'Geçerli sayfayı seç',
    'Clear selection': 'Seçimi temizle',
    'Open column settings': 'Sütun ayarlarını aç',
    'Open personal view selector': 'Kişisel görünüm seçicisini aç',
    'Clear table filters': 'Tablo filtrelerini temizle',
    'Clear current-page selection': 'Geçerli sayfa seçimini temizle',
    'Enter a view name of 1 to 60 characters.': '1 ile 60 karakter arasında bir görünüm adı girin.',
    'A personal view already has this name.': 'Bu adda bir kişisel görünüm zaten var.',
    'You can save up to 12 personal views.': 'En fazla 12 kişisel görünüm kaydedebilirsiniz.',
    'This personal view is no longer available.': 'Bu kişisel görünüm artık kullanılamıyor.',
    'Personal view saved.': 'Kişisel görünüm kaydedildi.',
    'Personal view applied. Unsupported settings are omitted.': 'Kişisel görünüm uygulandı. Desteklenmeyen ayarlar atlandı.',
    'Personal view renamed.': 'Kişisel görünüm yeniden adlandırıldı.',
    'Personal view deleted.': 'Kişisel görünüm silindi.',
    'Default view restored.': 'Varsayılan görünüm geri yüklendi.',
  },
}
